<mat-toolbar class="toolbar-container">
  @if (progressBarService.count | async) {
  <mat-progress-bar
    mode="indeterminate"
    class="progress-bar"></mat-progress-bar>
  } @if ((showToggleButton | async)!) {
  <button
    mat-icon-button
    class="menu-icon"
    (click)="navbarService.toggleMenu()">
    <mat-icon>menu</mat-icon>
  </button>
  }

  <span class="item-spacer"></span>

  @if (!!(authService.authUser | async)) {
  <!--    <button mat-icon-button>-->
  <!--      <mat-icon matBadge="1" matBadgeColor="warn" matBadgeSize="small">message</mat-icon>-->
  <!--    </button>-->
  <button mat-icon-button (click)="openSearch()" class="global-search">
    <mat-icon>search</mat-icon>
  </button>
  <!--    <button mat-icon-button (click)="authService.logout()">-->
  <!--      <mat-icon>logout</mat-icon>-->
  <!--    </button>-->
  <!--    <button mat-icon-button [matMenuTriggerFor]="settingsMenu">-->
  <!--      <mat-icon>settings</mat-icon>-->
  <!--    </button>-->
  <!--    <mat-menu #settingsMenu="matMenu">-->
  <!--      <button mat-menu-item (click)="authService.logout()">Logout</button>-->
  <!--    </mat-menu>-->
  }
</mat-toolbar>
